export default __webpack_public_path__ + "static/media/you-can-do-it-768w.355c04d0.webp";